import { Footer } from "@/modules/home/ui/components/Footer";
import { Header } from "@/modules/home/ui/components/Header";
import { BackToTop } from "@/modules/shared/ui/components/custom/back-to-top";

export function LandingPageLayout(props: { children: React.ReactNode }) {
  return (
    <div className="force-light bg-background">
      <Header />
      <main className="isolate">{props.children}</main>
      <Footer />
      <BackToTop />
    </div>
  )
}
